import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AnexoContratoResponse } from 'src/app/global/interfaces/anexo-contrato-response';
import { AnexoContratoService } from 'src/app/global/services/anexo-contrato.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { SinActividadComponent } from 'src/app/main/dialogs/full-screem/sin-inicio/sin-actividad.component';
import { AnexoContratoServiceVM } from 'src/app/view-model/services/anexo-contrato.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { ResumenServiceVM } from 'src/app/view-model/services/resumen-vm.service';
import { ValidacionEdicionServiceVM } from 'src/app/view-model/services/validacion-edicion.service';
import _ from 'lodash';



@Injectable()
export class AnexoContratoProviderVM extends AnexoContratoServiceVM {


    constructor(private anexoContratoService: AnexoContratoService, private valEdicionP3: ValidacionEdicionServiceVM,
                private productoService: vmProductosService, private resumenService: ResumenServiceVM,
                private localStorageService: LocalStorageService,
                private modalService: NgbModal
                
              ) {
        super();
    }


    getAnexoContrato(): Observable<any> {
        return this.anexoContratoService.getAnexoContrato()
            .pipe(map(this.getAnexoContratoOK), catchError(this.serviceError));
    }

    private getAnexoContratoOK(resp) {
        return resp;
    }

    getEstadoAnexos(): Observable<AnexoContratoResponse> {
        return this.anexoContratoService.getEstadoAnexos()
            .pipe(map(this.getEstadoAnexosOK), catchError(this.serviceError));
    }

    private getEstadoAnexosOK(resp) {
        return resp;
    }

    postApruebaDocumento(data): Observable<any> {
        return this.anexoContratoService.postApruebaDocumento(data)
            .pipe(map(this.postApruebaDocumentoOK), catchError(this.serviceError));
    }

    async postApruebaDocPromise(data): Promise<any> {
        return this.anexoContratoService.postApruebaDocumento(data)
            .pipe(map(this.postApruebaDocumentoOK), catchError(this.serviceError)).toPromise();
    }

    private postApruebaDocumentoOK(resp) {
        return resp;
    }

    postAprobarAnexoContratoComercio(): Observable<any> {
        return this.anexoContratoService.postAprobarAnexoContratoComercio()
            .pipe(map(this.postAprobarAnexoContratoComercioOK), catchError(this.serviceError));
    }

    private postAprobarAnexoContratoComercioOK(resp) {
        return resp;
    }

    postAprobarAnexoContratoRepresentante(): Observable<any> {
        return this.anexoContratoService.postAprobarAnexoContratoRepresentante()
            .pipe(map(this.postAprobarAnexoContratoRepresentanteOK), catchError(this.serviceError));
    }

    private postAprobarAnexoContratoRepresentanteOK(resp) {
        return resp;
    }

    getTipoAprobacion(): Observable<any> {
        return this.anexoContratoService.getTipoAprobacion()
            .pipe(map(this.getTipoAprobacionOK), catchError(this.serviceError));
    }

    private getTipoAprobacionOK(resp) {
        return resp;
    }


    getPreviewDocumento(): Observable<any> {

        return this.anexoContratoService.getPreviewDocumento()
        .pipe(map(this.getPreviewDocumentoOK), catchError(this.serviceError));
    }

    private getPreviewDocumentoOK(resp) {
        return resp.contenido;
    }

    private serviceError(error) {
        return throwError(error);
    }

    async obtenerAnexoContrato(): Promise<any> {
        return true;
    }

    async aprobarAnexo(data: AnexoContratoResponse): Promise<any> {
        const stepThree = this.localStorageService.getPaso3();
        const run = stepThree.persona.run;
        if (data.data.firmado === false) {
          const bodyFirmador = {
            runRepresentante: run,
            tipoDocumento: data.data.tipoDocumento,
            tipoAprobacion: 'ACEPTA_TERMINOS_Y_CONDICIONES'
          };
      
          try {
            await this.postApruebaDocPromise(bodyFirmador);
            console.debug('Documento firmado');
          } catch (error) {
            // Verificamos si el error tiene el mensaje esperado para levantar el modal
            if (
              error.error &&
              error.error.mensaje &&
              error.error.mensaje.contenido &&
              error.error.mensaje.contenido.includes('no tiene actividades economicas')
            ) {
              //($('#noActividadModal') as any).modal('show');
              this.abrirModalSinActividad();
              return false;
            }  
            
            // Si no es el error esperado, lo lanzamos para que sea capturado en otro nivel o se maneje de otra forma.
              throw error;
          }
      
          this.sleep(1000);
          const firmado = await this.getAnexoContrato().toPromise();
          if (firmado.data.firmado === true) {
            return true;
          }
          // Puedes definir un valor por defecto en caso de que no se cumpla la condición
          return false;
        } else {
          return true;
        }
      }
      
      private abrirModalSinActividad() {
        this.modalService.open(SinActividadComponent, { centered: true, backdrop: 'static', keyboard: false });
      }

    private sleep(ms) {
        return new Promise(resolve => {
            setTimeout(resolve, ms);
        });
    }
}
